import { FC, useEffect, useState } from "react";
import "./CalendarPassThankYouScreen.css";
import { useNavigate, useLocation } from "react-router-dom";
import allSetAnimation from "../../../assets/gif/pass-success-aniamtion.gif";
import allSetStar from "../../../assets/images/pass-success-icon.svg";
import appIcon from "../../../assets/images/header-sabehub-app-icon.svg";
import successEmoji from "../../../assets/images/payment-success-screen-success-emoji.svg";
import letsDoItIcon from "../../../assets/images/lets-do-it-icon.svg";
import calendarIcon from "../../../assets/images/calendar-pass-thanks-calendar-icon.svg";
import laptopIcon from "../../../assets/images/calendar-pass-thanks-laptop-icon.svg";
import userIcon from "../../../assets/images/calendar-pass-thanks-user-icon.svg";
import ROUTE_PATHS from "utils/routePaths";
import {
  formatWorkspaceTimeRange,
  getWorkspaceSlotTime,
  highlightLastWord,
} from "utils/utils";
import StageProgressView from "components/elements/StageProgressView";

const CalendarPassThankYouScreen: FC = () => {
  const navigate = useNavigate();
  const [selectedSlotData, setSelectedSlotData] = useState<any>(null);
  const [showGif, setShowGif] = useState(true);

  useEffect(() => {
    const storedSlotData = localStorage.getItem("selectedSlotData");
    if (storedSlotData) {
      setSelectedSlotData(JSON.parse(storedSlotData));
    }
  }, []);

  useEffect(() => {
    const timer = setTimeout(() => setShowGif(false), 4000);
    return () => clearTimeout(timer);
  }, []);

  const handleAllSetClick = () => {
    navigate(
      ROUTE_PATHS.WSM_WORKSPACE_DETAIL.replace(":slotId", selectedSlotData?.id),
      { replace: true, state: { fromThankYouScreen: true } },
    );
  };

  return (
    <div className="wms-mobile-container">
      <div className="calendar-pass-thank-you-screen-detail-screen-container">
        <div className="calendar-pass-thank-you-screen-header-sticky">
          <header className="calendar-pass-thank-you-screen-header-bar">
            <img src={appIcon} alt="header-app-icon" />
            <div className="calendar-pass-thank-you-screen-header-divider"></div>
            <span>{highlightLastWord("The Focus House")}</span>
          </header>
        </div>
        <div className="calendar-pass-thank-you-screen-detail-screen-content-container">
          {showGif ? (
            <img
              src={allSetAnimation}
              alt="all-set-animation"
              className="animation-container"
            />
          ) : (
            <img
              src={allSetStar}
              alt="all-set-complete"
              className="animation-container"
            />
          )}
          <div className="you-are-in-container">
            <span>Thank You</span>
            <img src={successEmoji} alt="success-emoji-icon" />
          </div>
          <div className="description-container">
            <span>
              Your{" "}
              <span style={{ color: "#C1F700" }}>Intention is locked in.</span>{" "}
              we’ll shape your{" "}
              <span style={{ color: "white" }}>
                space, meal and finish line
              </span>{" "}
              around it - before you even arrive.
            </span>
          </div>

          <div className="detail-container">
            <div className="header">What Happens Next</div>
            <div className="content-container">
              <img src={calendarIcon} alt="calendar-icon" />
              <div className="right">
                <span className="title">
                  {`${selectedSlotData?.location}, ${selectedSlotData?.sub_location} - arrive by ${getWorkspaceSlotTime(selectedSlotData?.start_time)}`}
                </span>
                <span>
                  {formatWorkspaceTimeRange(
                    selectedSlotData?.start_time,
                    selectedSlotData?.end_time,
                  )}
                </span>
              </div>
            </div>
            <div className="content-container">
              <img src={laptopIcon} alt="calendar-icon" />
              <div className="right">
                <span>
                  Bring your laptop, charger & headphones. come with the one
                  thing - we’ll handle the rest.
                </span>
              </div>
            </div>
            <div className="content-container">
              <img src={userIcon} alt="calendar-icon" />
              <div className="right">
                <span>
                  On the day, just arrive and settle in. your host takes it from
                  there.
                </span>
              </div>
            </div>
          </div>

          <div className="progress-container">
            <div className="text-container">
              <span>Focus House Journey</span>
              <span className="page-count">2 of 5</span>
            </div>
            <StageProgressView current_stage={2}></StageProgressView>
            <div className="text-container">
              <span className="footer-text">
                Finish this and your prep is{" "}
                <span className="footer-sub-text">100% done</span>
              </span>
            </div>
          </div>
          <span className="calendar-pass-thank-you-screen-footer-text">
            Takes under 2 minutes
          </span>
        </div>
      </div>
      <div
        className="calendar-pass-thank-you-screen-detail-purchase-btn"
        onClick={handleAllSetClick}
      >
        I'm All Set - See you at Venue
        <img src={letsDoItIcon} alt="right-arrow-icon" />
      </div>
    </div>
  );
};

export default CalendarPassThankYouScreen;
